import React, { useState } from 'react';
import { useCart } from '../../context';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faMinus, faPlus, faEdit, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Cart.css';

const Cart = () => {
    const { cart, removeFromCart, updateQuantity, updateComment } = useCart();
    // let a  = cartCheck();
    // if (a !== []) {
    //
    // }
    const navigate = useNavigate();
    const [editingComment, setEditingComment] = useState(null); // {id, size, comment}
    const [tempComment, setTempComment] = useState('');

    const handleQuantityChange = (item, change) => {
        const newQuantity = item.quantity + change;
        if (newQuantity >= 1 && newQuantity <= 10) {
            updateQuantity(item.id, item.size, item.comment, newQuantity);
        }
    };

    const startEditing = (item) => {
        setEditingComment({ id: item.id, size: item.size, comment: item.comment });
        setTempComment(item.comment || '');
    };

    const saveComment = (item) => {
        updateComment(item.id, item.size, item.comment, tempComment);
        setEditingComment(null);
    };

    const cancelEditing = () => {
        setEditingComment(null);
    };

    const calculateTotal = () => {
        return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
    };

    const handleCheckout = async () => {
        // Move to the dedicated place order page
        navigate('/checkout');
    };

    if (cart.length === 0) {
        return (
            <div className="cart-empty">
                <h2>Your cart is empty</h2>
                <Link to="/shop" className="continue-shopping">
                    Continue Shopping
                </Link>
            </div>
        );
    }

    return (
        <div className="cart-container">
            <h2>Shopping Cart</h2>
            <div className="cart-items">
                {cart.map((item) => (
                    <div key={`${item.id}-${item.size}-${item.comment}`} className="cart-item">
                        <div className="item-image">
                            <img src={item.imageUrl} alt={item.name} />
                        </div>
                        <div className="item-details">
                            <h3>{item.name}</h3>
                            {item.size && <p>Size: {item.size}</p>}
                            {editingComment && editingComment.id === item.id && editingComment.size === item.size && editingComment.comment === item.comment ? (
                                <div className="edit-comment-container">
                                    <input
                                        type="text"
                                        value={tempComment}
                                        onChange={(e) => setTempComment(e.target.value)}
                                        className="edit-comment-input"
                                        autoFocus
                                    />
                                    <button onClick={() => saveComment(item)} className="save-comment-btn">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </button>
                                    <button onClick={cancelEditing} className="cancel-comment-btn">
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </div>
                            ) : (
                                <div className="comment-display">
                                    {item.comment ? (
                                        <p className="item-comment">Note: {item.comment}</p>
                                    ) : (
                                        <p className="add-comment-link" onClick={() => startEditing(item)}>Add note</p>
                                    )}
                                    {item.comment && (
                                        <button className="edit-comment-btn" onClick={() => startEditing(item)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                    )}
                                </div>
                            )}
                            <p className="item-price">${item.price}</p>
                        </div>
                        <div className="quantity-controls">
                            <button
                                onClick={() => handleQuantityChange(item, -1)}
                                disabled={item.quantity === 1}
                            >
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                            <span>{item.quantity}</span>
                            <button
                                onClick={() => handleQuantityChange(item, 1)}
                                disabled={item.quantity === 10}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                        <div className="item-total">
                            ${(item.price * item.quantity).toFixed(2)}
                        </div>
                        <button
                            className="remove-item"
                            onClick={() => removeFromCart(item.id, item.size, item.comment)}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                ))}
            </div>
            <div className="cart-summary">
                <div className="cart-total">
                    <span>Total:</span>
                    <span>${calculateTotal().toFixed(2)}</span>
                </div>
                <button
                    className="checkout-button"
                    onClick={handleCheckout}
                >
                    Proceed to Checkout
                </button>
                <Link to="/shop" className="continue-shopping">
                    Continue Shopping
                </Link>
            </div>
        </div>
    );
};

export default Cart;